import React, {Component} from 'react';
import PieChart from 'react-minimal-pie-chart';
import {Route} from 'react-router-dom';
import cookie from "react-cookies";

import {FormInput, ValidateForm} from './common/formValidation';
import {Button, LoadingSpinner, RelativeSwitch} from './common/common';
import {reduxWrapper} from "../globalState";
import {formatPrice} from "../lib/tools";
import {LoginModal, Modal} from './common/modal';
import {ModalContext} from './../contexts';

//Manage affiliate routing
const AffiliateRender = ({userId}) => (
	<RelativeSwitch>
		<Route path=":code" render={({match: {params: {code}}}) => <AffiliateSignup key={userId} code={code}/>}/>
		<Route component={AffiliatePages}/>
	</RelativeSwitch>
);
export const Affiliate = reduxWrapper("getUserId")(AffiliateRender);

class AffiliateSignupRender extends Component {
	state = {
		id: null,
		user: null,
		email: "",
		name: "",
		account: "",
		password: ""
	};
	
	loaded = false;
	
	onSubmit = data => {
		if (this.state.user) {
			this.props.apiCall("POST", `/user/me/affiliates/${this.state.id}`, data => {
				this.props.history.replace("/affiliate");
			}, {reg: data.reg, account: data.account})
		} else {
			this.props.apiCall("POST", `/affiliate/${this.state.id}/user`, data => {
				this.props.login({data: {email: this.state.email, password: this.state.password}, success: this.props.history.replace("/affiliate")})
			}, data);
		}
	}
	
	componentWillMount() {
		this.props.apiCall("GET", "/affiliate", data => {
			this.setState({id: data.id});
			
			this.props.apiCall("GET", "/user/me", data => {
				this.loaded = true;
				this.setState({user: data, name: data.fullname, email: data.email});
			}, null, () => {
				this.loaded = true;
				this.setState({user: null, name: "", email: ""});
			});
			
		}, {code: this.props.code, customer: "null"}, () => this.props.history.replace("/affiliate"));
	}
	
	render() {
		if (!this.state.id) return <LoadingSpinner/>;
		const {user} = this.state;
		
		return (
			<Modal onHide={this.onHide} className="loginModals loginModal registerAffiliateModal" bg>
				<div className="loginMainWrapper">
					<div className="loginMain">
						<h1>Register som affiliate</h1>
						<ValidateForm className="login" values={this.state} onChange={val => this.setState(val)} onSubmit={this.onSubmit}>
							<FormInput name="email" title="Email" rules="email" req disabled={!!user}/>
							<FormInput name="name" title="Navn" req disabled={!!user}/>
							<FormInput type="number" name="reg" title="Reg nummer" rules="regNum" req/>
							<FormInput type="number" name="account" title="Konto nummer" rules="accNum" req/>
							{this.loaded && !user && <FormInput name="password" password req/>}
							<Button submit>Register</Button>
						</ValidateForm>
					</div>
				</div>
			</Modal>
		)
	}
}
const AffiliateSignup = reduxWrapper("getApiCall", "getLogin")(AffiliateSignupRender);

// The affiliate dashboard, shows statistics about the logged in affiliate parnter
class AffiliatePagesRender extends Component {
	static contextType = ModalContext;

	state = {
		navPos: 0,
		affiliate: {
			reg: "",
			account: "",
			code: "",
			payments: []
		},
		user: {
			email: "",
			name: "",
		}
	};

	//TODO: Change this dummy data to a response from API
	dummy = [
		{
			year: 2018,
			months: [
				{
					month: "Januar",
					traffic: 50,
					conversion: 2,
					comission: 132.54,
					paid: true
				},
				{
					month: "Februar",
					traffic: 68,
					conversion: 15,
					comission: 132.54,
					paid: true
				}
			]
		},
		{
			year: 2019,
			months: [
				{
					month: "Januar",
					traffic: 264,
					conversion: 100,
					comission: 265.78,
					paid: false
				},
				{
					month: "Februar",
					traffic: 1589,
					conversion: 486,
					comission: 1000.54,
					paid: false
				}
			]
		}
	]
	
	mounted = true;
	
	constructor(props) {
		super(props);
		
		this.editData = () => {
			//TODO: API calls for editing user data
		}
	}
	
	componentWillMount() {
		
		this.props.awaitUserData(data => {
			if (data.uid) {
				//this.props.apiCall("GET", "/user/me/affiliate", data => this.setState({affiliate: data}), null, () => this.props.history.replace("/"));
				this.props.apiCall("GET", "/user/me", data => this.state.mounted && this.setState({user: data}));
			} else {
				this.context.toggleModal(true, <LoginModal/>)
			}
		});
	}
	
	componentWillUnmount() {
		this.mounted = false;
	}
	
	render() {
		const {name} = this.props;
		const {navPos, affiliate} = this.state;
		return (
			<div id="afPages">
				<h1>Hi {name}!</h1>
				<p>
					Welcome to your affiliate dashboard. <br/>
					Here you can track your monthly earnings and edit your personal info.
				</p>
				<p>Affiliate link: www.festen.dk/partner/{affiliate.code}</p>
				<div className="afContentWrapper">
					<div className="navigation">
						<div className={"afNavLink" + (navPos !== 1 ? " afActive" : "")}
									onClick={() => this.setState({navPos: 0})}>Earnings
						</div>
						<div className={"afNavLink" + (navPos === 1 ? " afActive" : "")}
									onClick={() => this.setState({navPos: 1})}>Settings
						</div>
						<div className="afNavLink logout" onClick={() => this.props.logOut().then(() => this.props.history.replace("/"))}>LOGOUT</div>
					</div>
					<div className="afContent">
						{navPos === 1 ?
							<AffiliateEdit value={this.state} onChange={data => this.setState(data)} onSubmit={this.editData}/> :
							// <AffiliateOverview data={this.state.affiliate.payments}/>
							<AffiliateOverview data={this.dummy}/>
						}
					</div>
				</div>
			</div>
		)
	}
}
const AffiliatePages = reduxWrapper("getApiCall", "getLogOut")(AffiliatePagesRender);

// Affiliate user can edid his/hers information
const AffiliateEdit = ({value, onChange, onSubmit}) => (
	<div className="afSettings">
		<div className="afLoginContainer">
			<h1>Edit info</h1>
			<ValidateForm values={value} onChange={onChange} onSubmit={onSubmit}>
				<FormInput name="email" title="Email" rules="email"/>
				<FormInput name="name" title="Navn"/>
				<FormInput name="account" title="Konto nr"/>
				<FormInput name="OldPassword" title="Kodeord" type="password"/>
				<Button submit>GEM</Button>
			</ValidateForm>
		</div>
	</div>
);

// Affiliate data shown
const AffiliateOverview = ({data}) => (
	<div className="afEarningsWrapper">
	{
		data.map((x,i) => 
			<div key={i} className="earningsYear">
				<h1>Earnings {x.year}</h1>
				<div className="earnigsMonthWrapper">
					{
						x.months.map((y, i) =>
							<div className="month" key={i}>
								<h1 className="monthTitle">{y.month}</h1>
								<div className="monthConversion">
									<div className="pie">
									<PieChart
										data={[
											{ title: 'One', value: (y.conversion), color: '#619e98' },
											{ title: 'Two', value: (y.traffic - y.conversion), color: '#efefef' },
										]}
										style={{height: '100px'}}
										label={({ data, dataIndex }) =>
											dataIndex === 0 ?
											Math.round(data[dataIndex].percentage) + '%' : 
											""
										}
										labelStyle={{
											fontSize: '14px',
											fontFamily: 'Lato',
											fill: '#FFF'
										}}
									/>
									</div>
									<div className="piePieces">
										<div className="pieConversion">
											<span></span>
											Conversion rate
										</div>
									</div>
								</div>
								<span className="monthCommission">{formatPrice(y.comission)} DKK</span>
								<span className={y.paid ? "payedYes" : "payedNo"}>Paid: {y.paid ? "YES" : "NO"}</span>
							</div>
						)
					}
				</div>
			</div>
		)
	}
	</div>
);

class AffiliateRedirectRender extends React.Component {
	componentWillMount() {
		this.props.apiCall("GET", "/affiliate", data => {
			const date = new Date();
			date.setDate(date.getDate() + 7);
			cookie.save("affiliateCode", data.hash, {path: "/", expires: date});
			this.props.history.replace(`/?utm_source=affiliate&utm_campaign=${this.props.code}`);
		}, {code: this.props.code}, () => this.props.history.replace("/"));
	}
	
	render() {
		return <LoadingSpinner/>;
	}
}

export const AffiliateRedirect = reduxWrapper("getApiCall")(AffiliateRedirectRender);



// WEBPACK FOOTER //
// ./src/components/affiliate.js